import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import PropertyDetailPage from "@/pages/PropertyDetailPage";

import HomePage from "@/pages/HomePage";
import AnnouncementsPage from "@/pages/AnnouncementsPage";
import DocumentsPage from "@/pages/DocumentsPage";
import AmenitiesPage from "@/pages/AmenitiesPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PortalDashboard from "@/pages/PortalDashboard";
import BookingsPage from "@/pages/BookingsPage";
import PaymentsPage, { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentsPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import BookAmenityPage from "@/pages/BookAmenityPage";
import MyAccountPage from "@/pages/MyAccountPage";
import BoardPage from "@/pages/BoardPage";
import HomeownerReplyPage from "@/pages/HomeownerReplyPage";
import PaymentHistoryPage from "@/pages/PaymentHistoryPage";
import GetInvolvedPage from "@/pages/GetInvolvedPage";

function App() {
  return (
    <div className="App leaf-pattern min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Toaster richColors position="top-right" />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/announcements" element={<AnnouncementsPage />} />
              <Route path="/documents" element={<DocumentsPage />} />
              <Route path="/amenities" element={<AmenitiesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/portal" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
              <Route path="/portal/pay" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
              <Route path="/portal/bookings" element={<ProtectedRoute><BookingsPage /></ProtectedRoute>} />
              <Route path="/portal/history" element={<ProtectedRoute><PaymentHistoryPage /></ProtectedRoute>} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
              <Route path="/admin/properties/:id" element={<ProtectedRoute adminOnly><PropertyDetailPage /></ProtectedRoute>} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/portal/reply/:token" element={<HomeownerReplyPage />} />
              <Route path="/book" element={<ProtectedRoute><BookAmenityPage /></ProtectedRoute>} />
              <Route path="/book/:amenity" element={<ProtectedRoute><BookAmenityPage /></ProtectedRoute>} />
              <Route path="/account" element={<ProtectedRoute><MyAccountPage /></ProtectedRoute>} />
              <Route path="/portal/account" element={<ProtectedRoute><MyAccountPage /></ProtectedRoute>} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/volunteer" element={<GetInvolvedPage />} />
              <Route path="/get-involved" element={<GetInvolvedPage />} />
            </Routes>
          </main>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
